import { Injectable } from '@angular/core';
import { ExperiencesService } from '../../../../../../shared/services/experiences.service';
import { ConfigurableFormComponent } from '../../../../../../shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '../../../../../../shared/modules/configurable-form/models/on-field-changed';
import { UntypedFormGroup } from '@angular/forms';
import { FeatureToggleService } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '@ordersnproducts/features';
import { map } from 'rxjs/operators';
import { combineLatest, Observable } from 'rxjs';
import { SpecFieldNames } from '../../../../specification/constants/specification-field-names.enum';
import { Store } from '@ngrx/store';
import { OrderBuilderState } from '../../../../../reducers';
import { getUnloadTypes } from '../../../selectors/single-catalogs';
import { UNLOAD_TYPE_DEFAULT1, UNLOAD_TYPE_DEFAULT2 } from 'app/shared/pumping/pumping.constant';
import { ImUnloadType } from '@cemex-core/cmx-api';

@Injectable()
export class ResetUnloadTypeService implements OnFieldChanged {
  constructor(
    private experienceService: ExperiencesService,
    private featureToggle: FeatureToggleService,
    private store: Store<OrderBuilderState>,
  ) {}

  onFieldChanged(value, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    if (!!formGroup) {
      const toggle = this.featureToggle.isFeatureEnabled(Features.PUMP_PRIMER);
      const getUnloadTypes$ = this.store.select(getUnloadTypes);
      const getCommand2$ = this.experienceService.commandDcoEnabled$();

      combineLatest([getUnloadTypes$, getCommand2$])
        .pipe(
          map(([unloadTypes, isCommand2]) => {
            const getUnloadTypeDefault =
              !!unloadTypes && unloadTypes.length > 0
                ? unloadTypes.find(
                    (uType) =>
                      uType.unloadTypeCode === UNLOAD_TYPE_DEFAULT1 || uType.unloadTypeCode === UNLOAD_TYPE_DEFAULT2,
                  )
                : null;
            if ((!toggle || !isCommand2) && !!getUnloadTypeDefault) {
              formGroup.get(SpecFieldNames.UNLOAD_TYPE).setValue(getUnloadTypeDefault.unloadTypeCode);
            }
          }),
        )
        .subscribe();
    }
  }
}

@Injectable()
export class ResetUnloadTypeRepeatService implements OnFieldChanged {
  constructor(
    private experienceService: ExperiencesService,
    private featureToggle: FeatureToggleService,
    private store: Store<OrderBuilderState>,
  ) {}

  onFieldChanged(value, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    if (!!formGroup) {
      const toggle = this.featureToggle.isFeatureEnabled(Features.PUMP_PRIMER);
      const getCommand2$ = this.experienceService.commandDcoEnabled$();
      const getUnloadTypes$ = this.store.select(getUnloadTypes);
      validateUnloadType$(formGroup, getUnloadTypes$, toggle, getCommand2$).subscribe();
    }
  }
}

@Injectable()
export class ResetUnloadTypeModifyService implements OnFieldChanged {
  constructor(
    private experienceService: ExperiencesService,
    private featureToggle: FeatureToggleService,
    private store: Store<OrderBuilderState>,
  ) {}

  onFieldChanged(value, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    if (!!formGroup) {
      const toggle = this.featureToggle.isFeatureEnabled(Features.PUMP_PRIMER);
      const getCommand2$ = this.experienceService.commandDcoEnabled$();
      const getUnloadTypes$ = this.store.select(getUnloadTypes);
      validateUnloadType$(formGroup, getUnloadTypes$, toggle, getCommand2$).subscribe();
    }
  }
}

export function validateUnloadType$(
  formGroup: UntypedFormGroup,
  getUnloadTypes$: Observable<ImUnloadType[]>,
  toggle: boolean,
  getCommand2$: Observable<boolean>,
): Observable<void> {
  return combineLatest([getUnloadTypes$, getCommand2$]).pipe(
    map(([unloadTypes, isCommand2]) => {
      const getUnloadTypeDefault =
        !!unloadTypes && unloadTypes.length > 0
          ? unloadTypes.find(
              (uType) => uType.unloadTypeCode === UNLOAD_TYPE_DEFAULT1 || uType.unloadTypeCode === UNLOAD_TYPE_DEFAULT2,
            )
          : null;
      if ((!toggle || !isCommand2) && !!getUnloadTypeDefault && !formGroup.get(SpecFieldNames.UNLOAD_TYPE).value) {
        formGroup.get(SpecFieldNames.UNLOAD_TYPE).setValue(getUnloadTypeDefault.unloadTypeCode);
      }
    }),
  );
}
